import "core-js/modules/web.dom.iterable";
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { queryFace } from '@/api/api';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '18px'
    },
    left: {
      type: String,
      default: '0'
    }
  },
  data: function data() {
    return {
      chart: 'chart45',
      angle: 0
    };
  },
  mounted: function mounted() {
    this.getData();
  },
  methods: {
    getData: function getData() {
      var _this = this;

      queryFace().then(function (res) {
        if (res.success) {
          var data = [];
          res.result.forEach(function (item) {
            data.push({
              'name': item.faceType,
              'value': item.faceSum
            });
          });

          _this.initBarChart(data);
        }
      });
    },
    initBarChart: function initBarChart(data) {
      var colorList = ['#73DDFF', '#73ACFF', '#FDD56A', '#FDB36A', '#FD866A', '#9E87FF', '#58D5FF']; // 初始化数据

      var option = {
        tooltip: {
          trigger: 'item'
        },
        series: [{
          type: 'pie',
          center: ['50%', '50%'],
          radius: ['24%', '45%'],
          clockwise: true,
          avoidLabelOverlap: true,
          hoverOffset: 15,
          itemStyle: {
            normal: {
              color: function color(params) {
                return colorList[params.dataIndex];
              }
            }
          },
          label: {
            show: true,
            position: 'outside',
            formatter: '{b}\n\n{d}%',
            rich: {
              hr: {
                backgroundColor: 't',
                borderRadius: 3,
                width: 3,
                height: 3,
                padding: [3, 3, 0, -12]
              },
              a: {
                padding: [-30, 15, -20, 15]
              }
            }
          },
          labelLine: {
            normal: {
              length: 20,
              length2: 30,
              lineStyle: {
                width: 1
              }
            }
          },
          data: data
        }]
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    }
  }
};